export const userModes = {
  USER_CREATE: 'USER_CREATE',
  USER_EDIT: 'USER_EDIT'
};
